"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Thames21WaterQuality_exports = {};
__export(Thames21WaterQuality_exports, {
  Thames21ThamesWaterQuality: () => Thames21ThamesWaterQuality,
  Thames21WaterQuality: () => Thames21WaterQuality
});
module.exports = __toCommonJS(Thames21WaterQuality_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
function waterQualityMap(mapId, title) {
  return (0, import_core.mapSchemaWithDefaults)({
    mapId,
    title,
    layers: [
      (0, import_topo_map.pointLayer)({
        layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
        title,
        source: (0, import_core.cartographerSourceWithDefaults)({
          layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
          attribution: []
        }),
        defaultAttribute: "temperature",
        defaultZOrder: "timestamp",
        attributes: [
          (0, import_topo_map.attributeGroup)({
            label: "Survey",
            attributes: [
              (0, import_topo_map.teamAttr)("teamId", "Team"),
              (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
              (0, import_topo_map.attachmentAttr)("photographs", "Photographs"),
              (0, import_topo_map.timestampAttr)({
                attributeId: "timestamp",
                label: "Date/Time",
                buckets: "auto"
              })
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: title,
            attributes: [
              (0, import_topo_map.numberAttr)({
                attributeId: "ph",
                label: "pH",
                buckets: [
                  (0, import_topo_map.rangeBucket)(0, 1, import_topo_map.marker.ph(0)),
                  (0, import_topo_map.rangeBucket)(1, 2, import_topo_map.marker.ph(1)),
                  (0, import_topo_map.rangeBucket)(2, 3, import_topo_map.marker.ph(2)),
                  (0, import_topo_map.rangeBucket)(3, 4, import_topo_map.marker.ph(3)),
                  (0, import_topo_map.rangeBucket)(4, 5, import_topo_map.marker.ph(4)),
                  (0, import_topo_map.rangeBucket)(5, 6, import_topo_map.marker.ph(5)),
                  (0, import_topo_map.rangeBucket)(6, 7, import_topo_map.marker.ph(6)),
                  (0, import_topo_map.rangeBucket)(7, 8, import_topo_map.marker.ph(7)),
                  (0, import_topo_map.rangeBucket)(8, 9, import_topo_map.marker.ph(8)),
                  (0, import_topo_map.rangeBucket)(9, 10, import_topo_map.marker.ph(9)),
                  (0, import_topo_map.rangeBucket)(10, 11, import_topo_map.marker.ph(10)),
                  (0, import_topo_map.rangeBucket)(11, 12, import_topo_map.marker.ph(11)),
                  (0, import_topo_map.rangeBucket)(12, 13, import_topo_map.marker.ph(12)),
                  (0, import_topo_map.rangeBucket)(13, 14, import_topo_map.marker.ph(13), void 0, true)
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "temperature",
                label: "Temperature",
                unit: "C",
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, 3, import_topo_map.marker.fromColor("#2e3090")),
                  (0, import_topo_map.rangeBucket)(3, 6, import_topo_map.marker.fromColor("#0f4ca0")),
                  (0, import_topo_map.rangeBucket)(6, 9, import_topo_map.marker.fromColor("#0865b1")),
                  (0, import_topo_map.rangeBucket)(9, 12, import_topo_map.marker.fromColor("#0c7cc4")),
                  (0, import_topo_map.rangeBucket)(12, 15, import_topo_map.marker.fromColor("#1094d8")),
                  (0, import_topo_map.rangeBucket)(15, 18, import_topo_map.marker.fromColor("#14aded")),
                  (0, import_topo_map.rangeBucket)(18, 21, import_topo_map.marker.fromColor("#15a9c2")),
                  (0, import_topo_map.rangeBucket)(21, 24, import_topo_map.marker.fromColor("#6ea59f")),
                  (0, import_topo_map.rangeBucket)(24, 29, import_topo_map.marker.fromColor("#ea8133")),
                  (0, import_topo_map.rangeBucket)(29, null, import_topo_map.marker.fromColor("#be2432"))
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                attributeId: "turbidity",
                label: "Turbidity",
                unit: "NTU",
                buckets: [
                  (0, import_topo_map.thresholdBucket)(0, import_topo_map.marker.fromColor("#00acec")),
                  (0, import_topo_map.thresholdBucket)(12, import_topo_map.marker.fromColor("#00aad0")),
                  (0, import_topo_map.thresholdBucket)(13, import_topo_map.marker.fromColor("#24a8b9")),
                  (0, import_topo_map.thresholdBucket)(14, import_topo_map.marker.fromColor("#66a6a2")),
                  (0, import_topo_map.thresholdBucket)(15, import_topo_map.marker.fromColor("#8ba48d")),
                  (0, import_topo_map.thresholdBucket)(17, import_topo_map.marker.fromColor("#a9a178")),
                  (0, import_topo_map.thresholdBucket)(19, import_topo_map.marker.fromColor("#c49e60")),
                  (0, import_topo_map.thresholdBucket)(21, import_topo_map.marker.fromColor("#dd9948")),
                  (0, import_topo_map.thresholdBucket)(25, import_topo_map.marker.fromColor("#f69532")),
                  (0, import_topo_map.thresholdBucket)(30, import_topo_map.marker.fromColor("#e28b32")),
                  (0, import_topo_map.thresholdBucket)(40, import_topo_map.marker.fromColor("#cf8033")),
                  (0, import_topo_map.thresholdBucket)(50, import_topo_map.marker.fromColor("#be7633")),
                  (0, import_topo_map.thresholdBucket)(75, import_topo_map.marker.fromColor("#ae6d32")),
                  (0, import_topo_map.thresholdBucket)(100, import_topo_map.marker.fromColor("#9e6531")),
                  (0, import_topo_map.thresholdBucket)(150, import_topo_map.marker.fromColor("#905d2f")),
                  (0, import_topo_map.thresholdBucket)(200, import_topo_map.marker.fromColor("#82552e")),
                  (0, import_topo_map.thresholdBucket)(240, import_topo_map.marker.fromColor("#754d2c"))
                ]
              }),
              (0, import_topo_map.thresholdAttr)({
                attributeId: "dissolvedOxygen",
                label: "Dissolved Oxygen",
                unit: "ppm",
                buckets: [
                  (0, import_topo_map.thresholdBucket)(0, import_topo_map.marker.quality(0)),
                  (0, import_topo_map.thresholdBucket)(1, import_topo_map.marker.quality(0.2)),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(0.4)),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(0.5)),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(0.7)),
                  (0, import_topo_map.thresholdBucket)(8, import_topo_map.marker.quality(0.8)),
                  (0, import_topo_map.thresholdBucket)(10, import_topo_map.marker.quality(1))
                ]
              }),
              (0, import_topo_map.booleanAttr)({
                attributeId: "coliforms",
                label: "Coliforms",
                buckets: [
                  (0, import_topo_map.lookupBucket)(false, import_topo_map.marker.quality(0.8), "Absent (good)"),
                  (0, import_topo_map.lookupBucket)(true, import_topo_map.marker.quality(0.2), "Present (bad)")
                ]
              })
            ]
          })
        ]
      })
    ]
  });
}
const Thames21WaterQuality = waterQualityMap((0, import_topo_map.unsafeMapId)("thames21WaterQuality"), "Water Quality");
const Thames21ThamesWaterQuality = waterQualityMap(
  (0, import_topo_map.unsafeMapId)("thames21ThamesWaterQuality"),
  "Thames Water Quality"
);
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Thames21ThamesWaterQuality,
  Thames21WaterQuality
});
//# sourceMappingURL=Thames21WaterQuality.js.map
